import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=77e08b8a&lang=pug&"
import script from "./Header.ts?vue&type=script&lang=js&"
export * from "./Header.ts?vue&type=script&lang=js&"
import style0 from "./Header.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports